<template>
    <div class="flex flex-col items-start self-stretch">
        <div v-if="loading" class="flex justify-center items-center w-full py-4">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-orange"></div>
        </div>
        <div v-else-if="error" class="text-red-500 py-4">
            {{ error }}
        </div>
        <div v-else class="flex flex-col items-start self-stretch">
            <podcast-list-item
                v-for="(episode, index) in latestEpisodes"
                :key="episode.id"
                :episode="episode"
                :is-last-item="index === latestEpisodes.length - 1"
            />
        </div>
        <a
            href="https://10xtravel.com/podcast/"
            target="_blank"
            class="flex pt-4 flex-row items-center self-stretch text-slate-800 gap-1 font-medium text-md hover:text-orange"
        >
            View all
            <icon icon="link" class="w-4 h-4" />
        </a>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import PodcastListItem from './podcast-list-item.vue';

const loading = ref(false);
const error = ref(null);
const episodes = ref([]);

const latestEpisodes = computed(() => episodes.value.slice(0, 3));

const fetchEpisodes = async () => {
    loading.value = true;
    error.value = null;

    try {
        const response = await window.ApiService.apiCall('/podcasts', 'get');
        episodes.value = response.data.map(episode => ({
            id: episode.id,
            image: episode.image,
            title: episode.title,
            date: episode.date,
            duration: episode.duration || '00:00:00',
            link: episode.link
        }));
    } catch (e) {
        error.value = 'Failed to load episodes. Please try again later.';
        console.error('Error fetching episodes:', e);
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchEpisodes();
});
</script>
